export type SubMenu = {
    label: string;
    icon: string;
    pathIcon: string;
    command: any;
    ref: any;
    displaySeparator: boolean;
    visible: boolean;
}

export enum AdminMenuEnum {
    INSTITUTE,
    MEDICAL_PERSON,
    PERMISSIONS,
    FINANCIAL_GROUP,
    NOTIFICATION
} 

export enum SettingMenuEnum {
    HOME,
    ACCOUNT,
    INSTITUTE,
    PATIENT,
    DOC_PATIENT,
    AGENDA,
    TASK,
    BILLING,
    PERMISSION,
    NOTIFICATION
}